<div class="upload">
  <button type="button" class="large" color="primary" mat-raised-button="" [disabled]="disabled" (click)="uploader.click()">
    {{ label | translate }}
  </button>
  <input hidden="" type="file" #uploader="" (change)="onSelect($event.target.files[0])" [accept]="accept">
</div>